<template>
  <Modal
    v-model="_value"
    width="500"
    title="设置当天累计驾驶时间门限"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <Form :model="reqParams" :label-width="80">
      <FormItem prop="terminalNum" label="主机号">
        <Input v-model="reqParams.terminalNum" placeholder="请输入主机号">
        </Input>
      </FormItem>
      <FormItem prop="continueDriveLimitPerDay" label="当天累计驾驶时间门限">
        <Input v-model="reqParams.continueDriveLimitPerDay" placeholder="请输入当天累计驾驶时间门限">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setcontinuedrivelimitperdaymodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        reqParams: {
          terminalNum:'',
          continueDriveLimitPerDay:0
        }
      }
    },
    methods: {
      ...mapActions([
        'NetCommandServ_SetContinueDriveLimitPerDay'
      ]),
      onOk() {
        store.dispatch('NetCommandServ_SetContinueDriveLimitPerDay', {
          params: this.reqParams
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.reqParams.terminalNum = this._initValue
          this.reqParams.continueDriveLimitPerDay = 14400
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
